import React, { useLayoutEffect, useState } from "react";
import { Portal } from "react-portal";

export const ACCOUNT_HEADER_PORTAL_ID = "AccountHeader__Title";
export const AccountHeaderTitle: React.FC = ({ children }) => {
  const [node, setNode] = useState<HTMLElement | null>(
    document && document.getElementById(ACCOUNT_HEADER_PORTAL_ID),
  );

  useLayoutEffect(() => {
    setNode(document && document.getElementById(ACCOUNT_HEADER_PORTAL_ID));
  }, []);

  return node ? <Portal node={node}>{children}</Portal> : null;
};
